import React, { Component } from 'react'
import Banner from '../../components/tribe/tribe_banner2'
import './css/index.css'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer' 
import systemimage from '../../assets/image/strategy-organization/system.jpg'
export default class system extends Component {
    render() {
        const image=[
            {image:systemimage}
        ]
        return (
            <div>
                <Navbar/>
                <br/><br/><br/><br/><br className='hide-mobile'/><br className='hide-mobile'/>
                <div className='consulting-section'>
                    <Banner bread_crum={['Strategy and Organization','System']} image={image} title="System" subtitle=""/>
                    <br/><br/>
                    <div className='consulting-content'>
                        <h2>How we work</h2>
                        <br/><br/>
                        <div className='how'>
                            <p>
                                “We help our clients in developing and improving their business process that will deliver values and satisfaction to customers.”
                                <br/><br/>
                                …through
                                <br/><br/>
                                Value Chain & Process Mapping
                                <br/><br/>
                                For effective management of the organization, processes need to be identified and mapped according to the business value chain.
                                <br/><br/>
                                Process Improvement
                                <br/><br/>
                                To always improve their competitive advantage, organization must always improve their processes for better products and services to their stakeholders.
                                <br/><br/>
                                Process Documentation (SOP)
                                <br/><br/>
                                As working guidance for the employee, processes have to be documented in the form of Standard Operating Procedure.
                                <br/><br/>
                                Process Audit
                                <br/><br/>
                                Existing processes and the implementation have to be audited in regular basis to ensure compliance and to find areas for improvements.
                            </p>
                        </div>
                    </div>
                </div>
                <br/><br/>
                <Footer/>
            </div>
        )
    }
}
